import { triggerSnowplowSearchEvent } from '@themuse/snowplow-js-client';

export const SnowplowSearchTracker = ({
    searchType = 'job',
    searchId = null,
    searchKeyword = null,
    searchFilters = [],
    isRemote = false,
    fromCompanyJobsPage = false,
    callback = () => null,
    companyId = null,
}) => {
    const searchEventProps = {
        sp_search_type: searchType,
        sp_search_id: searchId,
        sp_search_keyword: searchKeyword,
    };
    if (fromCompanyJobsPage) {
        const userId = window.globalPageProps?.PAGE_PROPS?.session?.id;
        const index = window.dataLayer
            ? window.dataLayer.findIndex((obj) => 'sp_page_section' in obj)
            : null;
        const pageData = {
            sp_page_is_external: false,
            sp_page_page_company_id: companyId ? String(companyId) : null,
            sp_page_type: 'collection',
            sp_page_section: 'company_profile',
            sp_page_tab: 'company_jobs',
            sp_user_id: userId,
            sp_user_logged_in: !!userId,
        };
        if (index && index >= 0) {
            window.dataLayer[index] = pageData;
        } else if (index) {
            window.dataLayer.push(pageData);
        }
    }
    triggerSnowplowSearchEvent(searchEventProps, searchFilters, isRemote);
    callback();
};
